/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Card_DetailsInputs */

const en_new_card_details = /** @type {(inputs: New_Card_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Card Details`)
};

const fr_new_card_details = /** @type {(inputs: New_Card_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détails de la nouvelle carte`)
};

const de_new_card_details = /** @type {(inputs: New_Card_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Kartendetails`)
};

const it_new_card_details = /** @type {(inputs: New_Card_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovi dettagli della carta`)
};

const ru_new_card_details = /** @type {(inputs: New_Card_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новые данные карты`)
};

const es_new_card_details = /** @type {(inputs: New_Card_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevos detalles de la tarjeta`)
};

const zh_cn2_new_card_details = /** @type {(inputs: New_Card_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新卡详情`)
};

const ja_new_card_details = /** @type {(inputs: New_Card_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいカードの詳細`)
};

const hi_new_card_details = /** @type {(inputs: New_Card_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नए कार्ड का विवरण`)
};

const pt_pt2_new_card_details = /** @type {(inputs: New_Card_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novos detalhes do cartão`)
};

/**
* | output |
* | --- |
* | "New Card Details" |
*
* @param {New_Card_DetailsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_card_details = /** @type {((inputs?: New_Card_DetailsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Card_DetailsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_card_details(inputs)
	if (locale === "de") return de_new_card_details(inputs)
	if (locale === "it") return it_new_card_details(inputs)
	if (locale === "ru") return ru_new_card_details(inputs)
	if (locale === "es") return es_new_card_details(inputs)
	if (locale === "zh-CN") return zh_cn2_new_card_details(inputs)
	if (locale === "ja") return ja_new_card_details(inputs)
	if (locale === "hi") return hi_new_card_details(inputs)
	if (locale === "pt-PT") return pt_pt2_new_card_details(inputs)
	return en_new_card_details(inputs)
});